import Service from "./Service";
import { HotelOrderEntity } from "../model/hotel";
import { orderService } from "./orderService";
class hotelService extends orderService {
  // CheckRepeatOrder(data: any) {
  //   return this.post<any>("/HotelOrder/CheckRepeatOrder", data, {
  //     failTips: false,
  //   });
  // }
  // CreateOrder(data: HotelOrderEntity) {
  //   return this.post<HotelOrderEntity>(`/HotelOrder/CreateOrder`, data);
  // }
  // OrderDetails(UniqueID: string) {
  //   return this.get<HotelOrderEntity>(`/HotelOrder/OrderDetails?UniqueID=${UniqueID}`);
  // }
  // RefundJudge(UniqueID: string) {
  //   return this.get<any>(`/HotelOrder/RefundJudge?UniqueID=${UniqueID}`);
  // }
  // CreateAmend(amend: any) {
  //   return this.post<any>(`/HotelOrder/CreateAmend`, amend);
  // }
  // OrderCancel(id: string) {
  //   return this.get<any>(`/HotelOrder/OrderCancel?UniqueID=${id}`);
  // }
  // OrderSubmit(UniqueID: string) {
  //   return this.get<any>(`/HotelOrder/OrderSubmit/${UniqueID}`);
  // }
  // UpdateOrderStatus(id: string) {
  //   return this.get<any>(`/HotelOrder/UpdateOrderStatus?UniqueID=${id}`);
  // }
  // OrderRefund(data: any) {
  //   return this.post<any>("/HotelOrder/OrderRefund", data);
  // }
  // CreateOrderByPreference(data: any) {
  //   return this.post<any>("/HotelOrder/CreateOrderByPreference", data);
  // }
  // SearchOrders(id: string) {
  //   return this.get<any>(`/HotelOrder/SearchOrders?UniqueID=${id}`);
  // }
  // OrderRefundCancel(id: string) {
  //   return this.get<any>(`/HotelOrder/OrderRefundCancel?UniqueID=${id}`);
  // }
  getRefundPrice(id: string) {
    return this.get<HotelOrderEntity>(`/hotelorder/RefundPrice?id=${id}`);
  }
  getHotelOrderID(ClientUniqueID:string){
    return this.get<any>(`/hotelorder/GetOrderIDByClientUniqueID?ClientUniqueID=${ClientUniqueID}`)
  }
}
export default new hotelService("hotel", "HotelOrder");
